import {
	CircleDollarSign,
	Infinity as InfinityIcon,
	type LucideIcon,
} from "lucide-react";
import type { ObjPathProxy } from "ts-object-path";
import type { RentDrawdownMode } from "web_myplann/Goals/Forms/useGoalForm";
import type { MyPlannResourceDictionary } from "web_myplann/Infrastructure/Translations/ResourceDictionary";
import { Resources } from "web_myplann/Infrastructure/Translations/Resources";

type RentDrawdownOption = {
	value: RentDrawdownMode;
	icon: LucideIcon;
	labelKey: ObjPathProxy<MyPlannResourceDictionary, string>;
};

export const RENT_DRAWDOWN_OPTIONS: ReadonlyArray<RentDrawdownOption> = [
	{
		value: "to-zero",
		icon: CircleDollarSign,
		labelKey: Resources.Goals.Form.Pension.Drawdown.toZeroLabel,
	},
	{
		value: "perpetual",
		icon: InfinityIcon,
		labelKey: Resources.Goals.Form.Pension.Drawdown.perpetualLabel,
	},
];
